(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6453],{

/***/ 5398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _uuid = __webpack_require__(67429);
var _fp = __webpack_require__(78230);
var _lodash = _interopRequireDefault(__webpack_require__(96486));
var _excluded = ["type"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var _createNode = function createNode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    type = _ref.type,
    value = _ref.value,
    level = _ref.level,
    marks = _ref.marks;
  var markDefs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if ((0, _fp.isNil)(value)) {
    return null;
  }
  var determinedType = type || ((0, _fp.isString)(value) ? 'span' : 'block');
  if (determinedType === 'portableText') {
    return value;
  }
  if (determinedType === 'list') {
    return (0, _fp.compact)((0, _fp.map)(function (item) {
      return _createNode({
        level: item.level,
        type: 'listItem',
        value: [item]
      });
    }, value));
  }
  var output = {
    _key: (0, _uuid.v4)(),
    _type: determinedType // block, span, etc
  };
  var childMarkDefs = [];
  if (determinedType === 'listItem') {
    // eslint-disable-next-line no-underscore-dangle
    output._type = 'block';
    output.level = level || 1;
    output.listItem = 'bullet';
  }
  if (/^h[1-6]$/.test(determinedType)) {
    // eslint-disable-next-line no-underscore-dangle
    output._type = 'block';
    output.style = type;
  }

  // eslint-disable-next-line no-underscore-dangle
  if (output._type === 'block') {
    if ((0, _fp.isArray)(value)) {
      output.children = (0, _lodash["default"])(value).flatMap(function (item) {
        return _createNode(item, childMarkDefs);
      }).compact().value();
    } else if ((0, _fp.isString)(value)) {
      output.children = [_createNode({
        type: 'span',
        value: value,
        marks: marks
      }, childMarkDefs)];
    } else {
      output.children = (0, _fp.compact)([_createNode(value, childMarkDefs)]);
    }
  } else {
    output.text = value;
  }
  if (!(0, _fp.isEmpty)(marks)) {
    output.marks = (0, _fp.map)(function (mark) {
      if ((0, _fp.isString)(mark)) {
        return mark;
      }
      var markKey = (0, _uuid.v4)();
      var _type = mark.type,
        rest = _objectWithoutProperties(mark, _excluded);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      markDefs.push(_objectSpread({
        _type: _type,
        _key: markKey
      }, rest));
      return markKey;
    }, marks);
  }
  if (!(0, _fp.isEmpty)(childMarkDefs)) {
    output.markDefs = childMarkDefs;
  }
  return output;
};
var generatePortableText = function generatePortableText(content) {
  return (0, _fp.isArray)(content) ? _lodash["default"].flatMap(content, (0, _fp.ary)(1, _createNode)) : _createNode(content);
};
var _default = exports["default"] = generatePortableText;
module.exports = exports.default;

/***/ }),

/***/ 64355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _lodash = _interopRequireDefault(__webpack_require__(96486));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Joins together the text values contained in a PortableText object.
 *
 * @param {Array} blocks - Array of PortableText block objects to join.
 *
 * @returns {string} - The string contents of the PortableText.
 */
var portableTextToPlain = function portableTextToPlain() {
  var blocks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _lodash["default"])(blocks).map(function (block) {
    // if it's not a text block with children, return nothing
    // eslint-disable-next-line no-underscore-dangle
    if ((block === null || block === void 0 ? void 0 : block._type) !== 'block' || !(block !== null && block !== void 0 && block.children)) {
      return '';
    }
    // loop through the children spans, and join the
    // text strings
    return (0, _lodash["default"])(block === null || block === void 0 ? void 0 : block.children).map('text').join('');
  }).filter(function (text) {
    return !(0, _fp.isEmpty)(text);
  }).join('\n');
};
var _default = exports["default"] = portableTextToPlain;
module.exports = exports.default;

/***/ }),

/***/ 35420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _imageUrl = _interopRequireDefault(__webpack_require__(6803));
var _getWindow2 = _interopRequireDefault(__webpack_require__(27203));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DEFAULT_PIXEL_RATIO = 1;
var imageUrlBuilder = function imageUrlBuilder(config) {
  return function (source) {
    var _getWindow$devicePixe, _getWindow;
    var devicePixelRatio = (_getWindow$devicePixe = (_getWindow = (0, _getWindow2["default"])()) === null || _getWindow === void 0 ? void 0 : _getWindow.devicePixelRatio) !== null && _getWindow$devicePixe !== void 0 ? _getWindow$devicePixe : DEFAULT_PIXEL_RATIO;
    return (0, _imageUrl["default"])({
      dataset: config.dataset,
      projectId: config.projectId
    }).image(source).auto('format') // raster formats will use webp where available instead of png/jpg.
    .dpr(Math.min(5, devicePixelRatio)) // Set device pixel ratio when available (2x/3x res for retina screens).
    .fit('max') // Don't enlarge images when source image is smaller than width/height.
    .quality(80).width(5) // Set a tiny default, so we fail tiny and obvious instead of ruining performance.
    .height(5); // Set a tiny default, so we fail tiny and obvious instead of ruining performance.
  };
};
var _default = exports["default"] = imageUrlBuilder;
module.exports = exports.default;

/***/ }),

/***/ 27203:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : null;
};
var _default = exports["default"] = getWindow;
module.exports = exports.default;

/***/ }),

/***/ 55105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const lodash_1 = __importDefault(__webpack_require__(96486));
const assert_1 = __importDefault(__webpack_require__(27596));
const constants_1 = __webpack_require__(13294);
const LISTED_PRODUCT_TYPE_PATHS = {
    combined: 'hospital-extras-bundle',
    extras: 'extras-cover',
    hospital: 'hospital-cover',
    package: 'hospital-extras-packages',
};
function getProductUrl(args) {
    const { errorUrl, productId, rawUrl } = args || { errorUrl: undefined, productId: undefined, rawUrl: undefined };
    (0, assert_1.default)(lodash_1.default.isString(rawUrl), 'rawUrl must be a string');
    (0, assert_1.default)(lodash_1.default.isString(productId), 'productId must be a string');
    (0, assert_1.default)(lodash_1.default.isString(errorUrl), 'errorUrl must be a string');
    const type = lodash_1.default.findKey(constants_1.PRODUCTS_BY_TYPE, (products) => lodash_1.default.includes(products, productId));
    const parentProductId = lodash_1.default.findKey(constants_1.PRODUCTS_BY_PARENT, (products) => lodash_1.default.includes(products, productId));
    if (lodash_1.default.isUndefined(type) || lodash_1.default.isUndefined(productId)) {
        return errorUrl;
    }
    const productUrl = (0, lodash_1.default)(rawUrl)
        .replace(':type', LISTED_PRODUCT_TYPE_PATHS[type])
        .replace(':id', parentProductId || lodash_1.default.replace(productId, /(\b-excess-)[0-9]*/, ''));
    return productUrl;
}
module.exports = {
    getProductUrl,
};


/***/ }),

/***/ 47714:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/no-gap/[slug]",
      function () {
        return __webpack_require__(43821);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/components/content-tiles-section/index.tsx
var content_tiles_section = __webpack_require__(50739);
// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./src/client/pages/explained-term/detail/components/header-section/index.tsx
var header_section = __webpack_require__(58496);
// EXTERNAL MODULE: ./src/client/components/how-it-works/index.tsx + 3 modules
var how_it_works = __webpack_require__(93954);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/inclusions-exclusions/components/services/index.tsx







var Services = function(param) {
    var callout = param.callout, iconProps = param.iconProps, heading = param.heading, items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                looksLike: "h4",
                variant: "marginBottomSpacer11",
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* IconList */.Zd, {
                items: (0,_to_consumable_array/* default */.Z)((0,fp.map)(function(param) {
                    var text = param.name;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iconProps), {
                        text: text
                    });
                }, items)),
                variant: "simple"
            }),
            callout && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                variant: "marginTopSpacer11",
                children: callout
            })
        ]
    });
};
/* harmony default export */ var services = (Services);

;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/inclusions-exclusions/index.tsx






var colorGreen = "#0a5";
var colorRed = "#ff2828";
var InclusionsExclusions = function(param) {
    var excludedServices = param.excludedServices, includedServices = param.includedServices, name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        hideBorderTop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Section */.$0, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* AxisSwitcher */.e$, {
                        limit: 2,
                        space: "2rem",
                        threshold: "32rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(services, (0,_object_spread/* default */.Z)({
                                iconProps: {
                                    fill: colorGreen,
                                    icon: "tick-circle"
                                },
                                heading: "".concat((0,fp.capitalize)(name), " includes:")
                            }, includedServices)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(services, (0,_object_spread/* default */.Z)({
                                iconProps: {
                                    fill: colorRed,
                                    icon: "cross-circle"
                                },
                                heading: "Not included in ".concat((0,fp.lowerCase)(name), ":")
                            }, excludedServices))
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var inclusions_exclusions = (InclusionsExclusions);

// EXTERNAL MODULE: ./src/client/utils/map-terms-and-conditions-content/index.ts
var map_terms_and_conditions_content = __webpack_require__(24725);
// EXTERNAL MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-tiles/index.ts
var map_tiles = __webpack_require__(77013);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/actions/customer/index.ts
var customer = __webpack_require__(91395);
// EXTERNAL MODULE: ./src/client/models/price/load-price-for-component-props.ts
var load_price_for_component_props = __webpack_require__(14518);
// EXTERNAL MODULE: ./src/client/actions/price/index.ts
var price = __webpack_require__(77061);
// EXTERNAL MODULE: ./src/client/models/price/index.ts
var models_price = __webpack_require__(2798);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/index.tsx + 7 modules
var pricing_drawer = __webpack_require__(87022);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/client/utils/get-saleable-product-ids/index.ts
var get_saleable_product_ids = __webpack_require__(93216);
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/products/utils/filter-products/index.ts




var _obj;
var panelsByProductType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ahm_constants/* default.PRODUCT_TYPE.PACKAGE */.Z.PRODUCT_TYPE.PACKAGE, {
    heading: "Hospital and extras packages",
    productIds: [
        ahm_constants/* default.PRODUCT.LITE_FLEXI_BRONZE_PLUS_EXCESS_750 */.Z.PRODUCT.LITE_FLEXI_BRONZE_PLUS_EXCESS_750,
        ahm_constants/* default.PRODUCT.CLASSIC_FLEXI_SILVER_PLUS_EXCESS_750 */.Z.PRODUCT.CLASSIC_FLEXI_SILVER_PLUS_EXCESS_750,
        ahm_constants/* default.PRODUCT.DELUXE_FLEXI_SILVER_PLUS_EXCESS_750 */.Z.PRODUCT.DELUXE_FLEXI_SILVER_PLUS_EXCESS_750, 
    ]
}), (0,_define_property/* default */.Z)(_obj, ahm_constants/* default.PRODUCT_TYPE.EXTRAS */.Z.PRODUCT_TYPE.EXTRAS, {
    hasTwoLineName: true,
    heading: "Extras only",
    productIds: [
        ahm_constants/* default.PRODUCT.BLACK_50_SAVER_EXTRAS */.Z.PRODUCT.BLACK_50_SAVER_EXTRAS,
        ahm_constants/* default.PRODUCT.BLACK_60_EXTRAS */.Z.PRODUCT.BLACK_60_EXTRAS,
        ahm_constants/* default.PRODUCT.BLACK_70_BOOST_EXTRAS */.Z.PRODUCT.BLACK_70_BOOST_EXTRAS,
        ahm_constants/* default.PRODUCT.BLACK_70_EXTRAS */.Z.PRODUCT.BLACK_70_EXTRAS,
        ahm_constants/* default.PRODUCT.FAMILY_EXTRAS */.Z.PRODUCT.FAMILY_EXTRAS,
        ahm_constants/* default.PRODUCT.LIFESTYLE_EXTRAS */.Z.PRODUCT.LIFESTYLE_EXTRAS,
        ahm_constants/* default.PRODUCT.SUPER_EXTRAS */.Z.PRODUCT.SUPER_EXTRAS,
        ahm_constants/* default.PRODUCT.VALUE_EXTRAS */.Z.PRODUCT.VALUE_EXTRAS, 
    ]
}), _obj);
// @ts-expect-error - Automatic, Please fix when editing this file
var filterProducts = function(param) {
    var productType = param.productType, products = param.products;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var productIds = panelsByProductType[productType].productIds;
    var saleableProductIds = (0,get_saleable_product_ids/* default */.Z)();
    return (0,fp.sortBy)("rank", (0,fp.filter)(function(product) {
        return (0,fp.includes)(product.id, productIds) && (0,fp.includes)(product.id, saleableProductIds);
    }, products));
};
/* harmony default export */ var filter_products = (filterProducts);

// EXTERNAL MODULE: ./src/client/features/no-gap-dental/utils/get-is-no-gap-dental-product/index.ts
var get_is_no_gap_dental_product = __webpack_require__(4529);
// EXTERNAL MODULE: ./src/client/utils/prepare-product-for-product-tile/index.ts
var prepare_product_for_product_tile = __webpack_require__(59794);
// EXTERNAL MODULE: ./src/client/components/price-disclaimer/index.tsx + 2 modules
var price_disclaimer = __webpack_require__(76383);
// EXTERNAL MODULE: ./src/client/utils/get-frequency-options/index.tsx
var get_frequency_options = __webpack_require__(26089);
// EXTERNAL MODULE: ./src/client/utils/get-scale-options/index.tsx
var get_scale_options = __webpack_require__(94562);
// EXTERNAL MODULE: ./src/client/actions/modal/index.ts
var modal = __webpack_require__(18826);
// EXTERNAL MODULE: ./src/client/components/premium-review-toggle-wrapper/index.tsx + 2 modules
var premium_review_toggle_wrapper = __webpack_require__(12224);
// EXTERNAL MODULE: ./src/client/actions/product-listing-overlay/index.ts
var product_listing_overlay = __webpack_require__(86662);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/components/segmentation-bar/styles.module.sass
var styles_module = __webpack_require__(48359);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/segmentation-bar/index.tsx
















var stateOptions = ahm_constants/* default.STATE_OPTIONS */.Z.STATE_OPTIONS;
var defaultScaleOptions = (0,get_scale_options/* default */.Z)({
    endText: "cover",
    format: fp.toLower
});
var frequencyOptions = (0,get_frequency_options/* default */.Z)({
    endText: "ly",
    format: fp.toLower
});
var productTypeOptions = ahm_constants/* default.PRODUCT_TYPE_OPTIONS */.Z.PRODUCT_TYPE_OPTIONS;
var SegmentationBar = function(param) {
    var actions = param.actions, frequency = param.frequency, product = param.product, productType = param.productType, productTypes = param.productTypes, scale = param.scale, showProductType = param.showProductType, state = param.state;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'scales' does not exist on type '{}'.
    var selectable = product === null || product === void 0 ? void 0 : (ref = product.scales) === null || ref === void 0 ? void 0 : ref.selectable;
    var scaleOptions = selectable ? (0,fp.map)(function(value) {
        return {
            text: (0,fp.lowerCase)(value),
            value: value
        };
    }, selectable) : defaultScaleOptions;
    var filteredProductTypeOptions = (0,fp.isArray)(productTypes) ? (0,fp.filter)(function(option) {
        return (0,fp.includes)(option.value, productTypes);
    }, productTypeOptions) : productTypeOptions;
    var props = {
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'customer' does not exist on type '{}'.
        changeFrequency: actions === null || actions === void 0 ? void 0 : (ref1 = actions.customer) === null || ref1 === void 0 ? void 0 : ref1.changeFrequency,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'customer' does not exist on type '{}'.
        changeProductType: actions === null || actions === void 0 ? void 0 : (ref2 = actions.customer) === null || ref2 === void 0 ? void 0 : ref2.changeProductType,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'customer' does not exist on type '{}'.
        changeScale: actions === null || actions === void 0 ? void 0 : (ref3 = actions.customer) === null || ref3 === void 0 ? void 0 : ref3.changeScale,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'customer' does not exist on type '{}'.
        changeState: actions === null || actions === void 0 ? void 0 : (ref4 = actions.customer) === null || ref4 === void 0 ? void 0 : ref4.changeState,
        frequency: frequency,
        frequencyOptions: frequencyOptions,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'productListingOverlay' does not exist on type '{}'.
        onEdit: actions === null || actions === void 0 ? void 0 : (ref5 = actions.productListingOverlay) === null || ref5 === void 0 ? void 0 : ref5.productListingOverlayShowing,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'productListingOverlay' does not exist on type '{}'.
        onRead: actions === null || actions === void 0 ? void 0 : (ref6 = actions.productListingOverlay) === null || ref6 === void 0 ? void 0 : ref6.productListingOverlayHidden,
        product: product,
        productType: productType,
        productTypeOptions: filteredProductTypeOptions,
        scale: scale,
        scaleOptions: scaleOptions,
        showProductType: showProductType,
        state: state,
        stateOptions: stateOptions
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SegmentationBar */.R$, (0,_object_spread/* default */.Z)({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).toggleWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_toggle_wrapper/* default */.ZP, {
                    showBackground: true
                })
            })
        ]
    });
};
SegmentationBar.defaultProps = {
    product: {},
    productTypes: null,
    showPremiumChangeDropdown: true,
    showProductType: true
};
var mapStateToProps = function(state) {
    return (0,fp.pick)([
        "frequency",
        "scale",
        "state",
        "productType"
    ], (0,select_customer/* default */.Z)(state));
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            customer: (0,redux/* bindActionCreators */.DE)(customer/* default */.Z, dispatch),
            modal: (0,redux/* bindActionCreators */.DE)(modal/* default */.Z, dispatch),
            productListingOverlay: (0,redux/* bindActionCreators */.DE)(product_listing_overlay/* default */.Z, dispatch)
        }
    };
};
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type '{ ({ actions, frequency, product, productType, productTypes, scale, showProductType, state, }: SegmentationBarProps): JSX.Element; defaultProps: { product: {}; productTypes: null; showPremiumChangeDropdown: boolean; showProductType: boolean; }; }' is not assignable to parameter of type 'JSXElementConstructor<Matching<Pick<Customer, "scale" | "productType" | "state" | "frequency"> & { actions: { customer: { changeAddress: (address: any) => { address: any; type: string; }; changeContinuousCover: (continuous: any, memberRelationship: any) => { ...; }; ... 15 more ...; changeSwitching: (switching: any)...'.
/* harmony default export */ var segmentation_bar = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(SegmentationBar));


;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/state-dentist-logo/images/citydental.png
/* harmony default export */ var citydental = ({"src":"/_next/static/media/citydental.2e660174.png","height":160,"width":420,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAWUlEQVR4nF3KMQrAIBAF0b8YTKVFhAixifc/hzmEacXeRlaEJdaZcng056ylFBhj4dyBf5TzW1N6EOMN708wD2itISII4QK11iqPgX3N3juICEptCzKsNfgANeggTbKrxQYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/state-dentist-logo/images/crottydental.png
/* harmony default export */ var crottydental = ({"src":"/_next/static/media/crottydental.6cb49fef.png","height":160,"width":280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAhUlEQVR42mNgMIhScUyyDcxhYPBg0IlgUAlhUAnlMY9lYGD0rWicMGvh6hnzVq7bvHvF2m3xOfUMckEMDIrBkek1Td0zSuv7atumdEyYG5tVxyAVyMCgG+EUVpBa1Bqf2xidWZdR2uEZVcygGcbAYBSl7JBk5Jmu5pQMROa+WWLW8QzG0QDhYyhgiu0K2wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/state-dentist-logo/images/danieltan.png
/* harmony default export */ var danieltan = ({"src":"/_next/static/media/danieltan.d4794a6c.png","height":160,"width":952,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAIAAABsYngUAAAAHklEQVR42mP49u3rp0+fXoHByxcvXr9+DeR+/foVABgCFmPoLp9sAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/state-dentist-logo/images/dbdental.png
/* harmony default export */ var dbdental = ({"src":"/_next/static/media/dbdental.b1d9548d.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAApUlEQVR42mWNQQuCQBCF/f/XCDpFRFBRUagUhWfTMmshryIaW26ktuwcCndsFW99l3m8D95oiFj9oUpNHUqpdzxwzpMkDoKrEEKVtVibhrO3l4v5cNDvdTvkcm7FZrd1T97KNEbT8WQ+s12nEQA3Qhxdz8Mw8n1iWSoggIZl+eX8w5iIIohjFSQASllP5e+Cpg+WvZ55dmdpwXn7QzZgQ4VqokTEH7k0rO8CsxuNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/state-dentist-logo/images/easternshoredental.jpg
/* harmony default export */ var easternshoredental = ({"src":"/_next/static/media/easternshoredental.e511ee47.jpg","height":145,"width":346,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAMACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABgEBAQAAAAAAAAAAAAAAAAAAAAL/2gAMAwEAAhADEAAAAIUJ/8QAHRAAAQIHAAAAAAAAAAAAAAAAAgMEAAEFERITQf/aAAgBAQABPwCpvnSTrAFbDrDko//EABgRAAIDAAAAAAAAAAAAAAAAAAACAzNx/9oACAECAQE/AIq0w//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMBAT8Af//Z","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/state-dentist-logo/images/nationaldentalcare.png
/* harmony default export */ var nationaldentalcare = ({"src":"/_next/static/media/nationaldentalcare.33e0968f.png","height":114,"width":294,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAYklEQVR4nGP0OnTQh+E/Ax8jE+OPrbZ2GxksvLQZGBj+MPz//x1I3wcpsAJyGJhYWLhfnLt08cz01UGM/JzM//+BFdwCKRAHmvCLgZHB+t/vPwd3ODv/4nAJYv7xGSTPwA0AesQn1Q0kpmkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/state-dentist-logo/images/pacificsmiles.jpg
/* harmony default export */ var pacificsmiles = ({"src":"/_next/static/media/pacificsmiles.acecfb0d.jpg","height":200,"width":200,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAKYKP//EABgQAQADAQAAAAAAAAAAAAAAAAECAxIA/9oACAEBAAE/ACi0vI6jompHXf/EABYRAQEBAAAAAAAAAAAAAAAAAAEAMf/aAAgBAgEBPwBcv//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMBAT8Af//Z","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/state-dentist-logo/styles.module.sass
var state_dentist_logo_styles_module = __webpack_require__(1241);
var state_dentist_logo_styles_module_default = /*#__PURE__*/__webpack_require__.n(state_dentist_logo_styles_module);
// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/state-dentist-logo/index.tsx















var logos = {
    cityDental: {
        cssClass: "city",
        img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
            alt: "City Dental",
            src: citydental.src
        })
    },
    crottyDental: {
        cssClass: "logo",
        img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
            alt: "Crotty Dental",
            src: crottydental.src
        })
    },
    danielTan: {
        cssClass: "danielTan",
        img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
            alt: "Daniel Tan",
            src: danieltan.src
        })
    },
    dbDental: {
        cssClass: "logo",
        img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
            alt: "Db Dental",
            src: dbdental.src
        })
    },
    easternShoreDental: {
        cssClass: "logo",
        img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
            alt: "Eastern Shore Dental",
            src: easternshoredental.src
        })
    },
    nationalDentalCare: {
        cssClass: "logo",
        img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
            alt: "National Dental Care",
            src: nationaldentalcare.src
        })
    },
    pacific: {
        cssClass: "logo",
        img: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
            alt: "Pacific Smiles Dental",
            src: pacificsmiles.src
        })
    }
};
var state_dentist_logo_obj;
var STATE_LOGO_MAP = (state_dentist_logo_obj = {}, (0,_define_property/* default */.Z)(state_dentist_logo_obj, ahm_constants/* default.STATE.ACT */.Z.STATE.ACT, [
    logos.pacific
]), (0,_define_property/* default */.Z)(state_dentist_logo_obj, ahm_constants/* default.STATE.NSW */.Z.STATE.NSW, [
    logos.pacific
]), (0,_define_property/* default */.Z)(state_dentist_logo_obj, ahm_constants/* default.STATE.NT */.Z.STATE.NT, [
    logos.nationalDentalCare
]), (0,_define_property/* default */.Z)(state_dentist_logo_obj, ahm_constants/* default.STATE.QLD */.Z.STATE.QLD, [
    logos.pacific
]), (0,_define_property/* default */.Z)(state_dentist_logo_obj, ahm_constants/* default.STATE.SA */.Z.STATE.SA, [
    logos.nationalDentalCare
]), (0,_define_property/* default */.Z)(state_dentist_logo_obj, ahm_constants/* default.STATE.TAS */.Z.STATE.TAS, [
    logos.crottyDental,
    logos.cityDental,
    logos.danielTan,
    logos.easternShoreDental
]), (0,_define_property/* default */.Z)(state_dentist_logo_obj, ahm_constants/* default.STATE.VIC */.Z.STATE.VIC, [
    logos.pacific
]), (0,_define_property/* default */.Z)(state_dentist_logo_obj, ahm_constants/* default.STATE.WA */.Z.STATE.WA, [
    logos.dbDental
]), state_dentist_logo_obj);
var StateDentistLogo = function(param) {
    var state = param.state;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (state_dentist_logo_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.H2, {
                looksLike: "h5",
                variant: "regular",
                children: [
                    "Participating dentists in ",
                    (0,fp.startCase)(state)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                lgHorizontalAlign: "left",
                smHorizontalAlign: "center",
                children: (0,uncap_fp_iterator/* default */.Z)(fp.map)(// @ts-expect-error - Automatic, Please fix when editing this file
                function(param, index) {
                    var img = param.img, cssClass = param.cssClass;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        variant: [
                            (state_dentist_logo_styles_module_default()).column,
                            (state_dentist_logo_styles_module_default())[cssClass]
                        ],
                        xs: 12,
                        df: true,
                        children: img
                    }, index);
                }, // @ts-expect-error - Automatic, Please fix when editing this file
                STATE_LOGO_MAP[state])
            })
        ]
    });
};
/* harmony default export */ var state_dentist_logo = (StateDentistLogo);

// EXTERNAL MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/products/styles.module.sass
var products_styles_module = __webpack_require__(77688);
var products_styles_module_default = /*#__PURE__*/__webpack_require__.n(products_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/components/products/index.tsx















var smallThreshold = "44rem";
var _URLS = ahm_constants/* default.URLS */.Z.URLS, CHOOSABLE_PICKER = _URLS.SALES.CHOOSABLE_PICKER;
var choosableProductTileContent = {
    content: {
        longForm: "With our new choosable extras, simply start with our base bundle of teeth and emergency ambulance, then choose the extras bundles that you’ll actually use."
    },
    name: "choosable extras",
    url: CHOOSABLE_PICKER
};
var Products = function(param) {
    var customer = param.customer, isLoadingPrice = param.isLoadingPrice, isProductWithHospitalServices = param.isProductWithHospitalServices, prices = param.prices, productTypes = param.productTypes, products = param.products, useFutureEffectiveDate = param.useFutureEffectiveDate;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var productType = customer.productType;
    if (!(0,fp.includes)(productType)(productTypes)) {
        return null;
    }
    var filteredProducts = filter_products({
        productType: productType,
        products: products
    });
    var productTileProducts = (0,fp.flow)(// @ts-expect-error - Automatic, Please fix when editing this file
    (0,fp.map)((0,prepare_product_for_product_tile/* default */.Z)({
        customer: customer,
        frequency: customer.frequency,
        prices: prices,
        useFutureEffectiveDate: useFutureEffectiveDate
    })), // @ts-expect-error - Automatic, Please fix when editing this file
    (0,fp.filter)(function(product) {
        return (0,get_is_no_gap_dental_product/* default */.Z)({
            product: product,
            state: customer.state
        });
    }))(filteredProducts);
    var productTileProductsProcessed = !isProductWithHospitalServices ? (0,fp.concat)(choosableProductTileContent, productTileProducts) : productTileProducts;
    var amountOfProducts = (0,fp.size)(productTileProductsProcessed);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Section */.$0, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Wrapper */.im, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                            variant: [
                                "center",
                                "marginBottomSpacer9"
                            ],
                            children: "Choose from the below cover options"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: 12,
                        variant: "marginBottomSpacer9",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                            variant: "center",
                            children: "These products include no gap dental check-ups at select dentists^"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: 12,
                        variant: [
                            "marginBottomSpacer7"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(segmentation_bar, {
                            productTypes: productTypes
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                    variant: [
                        "marginBottomSpacer7",
                        (products_styles_module_default()).axisSwitcherWrapper
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* AxisSwitcher */.e$, {
                        limit: amountOfProducts,
                        space: "1rem",
                        threshold: smallThreshold,
                        children: (0,fp.map)(function(product) {
                            return(// @ts-expect-error - Automatic, Please fix when editing this file
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (products_styles_module_default()).productTileWrapper,
                                children: /*#__PURE__*/ (0,react.createElement)(ahm_ui/* ProductTile */.vB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                                    "url",
                                    "content"
                                ])(product)), {
                                    isLoadingPrice: isLoadingPrice,
                                    // @ts-expect-error - Automatic, Please fix when editing this file
                                    key: product.url,
                                    // @ts-expect-error - Automatic, Please fix when editing this file
                                    linkTo: product.url,
                                    blurb: (0,fp.get)("content.longForm")(product),
                                    variant: (products_styles_module_default()).productTile,
                                    showPrice: isLoadingPrice || (0,fp.get)("price")(product) !== undefined
                                }))
                            }, product.url));
                        })(productTileProductsProcessed)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(price_disclaimer/* default */.ZP, {
                            bold: true,
                            forProducts: filteredProducts,
                            highlightIncome: true,
                            showRefineLink: true,
                            center: true,
                            constrainWidth: true
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (products_styles_module_default()).footnote,
                    children: "^Excludes specialists"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                            variant: [
                                "center"
                            ],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(state_dentist_logo, {
                                state: customer.state
                            })
                        })
                    })
                })
            ]
        })
    });
};
Products.defaultProps = {
    customer: null,
    isLoadingPrice: false,
    prices: null,
    products: null,
    useFutureEffectiveDate: false
};
/* harmony default export */ var components_products = (Products);

;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/components/no-gap-dental-products/index.tsx














var PRODUCT_TYPES = [
    ahm_constants/* default.PRODUCT_TYPE.PACKAGE */.Z.PRODUCT_TYPE.PACKAGE,
    ahm_constants/* default.PRODUCT_TYPE.EXTRAS */.Z.PRODUCT_TYPE.EXTRAS
];
var NoGapProducts = function(param) {
    var actions = param.actions, customer = param.customer, isLoadingPrice = param.isLoadingPrice, prices = param.prices, products = param.products, useFutureEffectiveDate = param.useFutureEffectiveDate;
    var isProductWithHospitalServices = customer.productType === ahm_constants/* default.PRODUCT_TYPE.PACKAGE */.Z.PRODUCT_TYPE.PACKAGE;
    var customerChange = models_price/* default.getKey */.Z.getKey("", customer);
    var changedProducts = JSON.stringify(products);
    (0,react.useEffect)(function() {
        if (!(0,fp.isEmpty)(products)) {
            load_price_for_component_props/* default.componentDidMount */.Z.componentDidMount({
                actions: actions,
                customer: customer,
                products: products,
                useFutureEffectiveDate: useFutureEffectiveDate
            });
        }
    }, [
        customerChange,
        changedProducts,
        useFutureEffectiveDate
    ]);
    (0,react.useEffect)(function() {
        if (!(0,fp.isEmpty)(products)) {
            actions.customer.changeHospitalExcess("750");
            if (!(0,fp.includes)(customer.productType, PRODUCT_TYPES)) {
                actions.customer.changeProductType(ahm_constants/* default.PRODUCT_TYPE.PACKAGE */.Z.PRODUCT_TYPE.PACKAGE);
            }
            load_price_for_component_props/* default.componentDidMount */.Z.componentDidMount({
                actions: actions,
                customer: customer,
                products: products,
                useFutureEffectiveDate: useFutureEffectiveDate
            });
        }
    }, []);
    if ((0,fp.isEmpty)(products)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
                hideBorderTop: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
                    padding: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                        variant: [
                            "paddingTopSpacer3",
                            "paddingBottomSpacer3"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_products, {
                            customer: customer,
                            isLoadingPrice: isLoadingPrice,
                            isProductWithHospitalServices: isProductWithHospitalServices,
                            prices: prices,
                            productTypes: PRODUCT_TYPES,
                            products: products,
                            useFutureEffectiveDate: useFutureEffectiveDate
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_drawer/* default */.Z, {
                isProductWithHospitalServices: isProductWithHospitalServices
            })
        ]
    });
};
var no_gap_dental_products_mapStateToProps = function(state) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        isLoadingPrice: state.price.loading,
        prices: state.price.data,
        products: state.product.data,
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var no_gap_dental_products_mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            customer: (0,redux/* bindActionCreators */.DE)(customer/* default */.Z, dispatch),
            price: (0,redux/* bindActionCreators */.DE)(price/* default */.Z, dispatch)
        }
    };
};
/* harmony default export */ var no_gap_dental_products = ((0,es/* connect */.$j)(no_gap_dental_products_mapStateToProps, no_gap_dental_products_mapDispatchToProps)(NoGapProducts));


// EXTERNAL MODULE: ./src/client/components/terms-and-conditions/index.tsx
var terms_and_conditions = __webpack_require__(47828);
// EXTERNAL MODULE: ./src/client/components/sections/terms-section/index.tsx
var terms_section = __webpack_require__(27440);
;// CONCATENATED MODULE: ./src/client/pages/no-gap/detail/index.tsx












var NoGapDetailPage = function(param) {
    var noGapDetailData = param.noGapDetailData;
    var excludedServices = noGapDetailData.excludedServices, howTo = noGapDetailData.howTo, includedServices = noGapDetailData.includedServices, identifier = noGapDetailData.identifier, name = noGapDetailData.name, summary = noGapDetailData.summary, termsAndConditions = noGapDetailData.termsAndConditions, tiles = noGapDetailData.tiles;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var content = (0,map_tiles/* default */.Z)({
        cmsSectionContent: tiles
    }).content;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var terms = (0,map_terms_and_conditions_content/* default */.Z)({
        cmsSectionContent: termsAndConditions
    }).terms;
    var _current;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: (_current = identifier.current) !== null && _current !== void 0 ? _current : undefined
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_section/* default */.Z, {
                summary: summary,
                name: name,
                slogan: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(inclusions_exclusions, {
                excludedServices: excludedServices,
                includedServices: includedServices,
                name: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(how_it_works/* default */.Z, {
                howTo: howTo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(no_gap_dental_products, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(content_tiles_section/* default */.Z, {
                contentTiles: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_section/* default */.Z, {
                termsComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_and_conditions/* default */.Z, {
                    terms: terms
                })
            })
        ]
    });
};
/* harmony default export */ var detail = (NoGapDetailPage);

;// CONCATENATED MODULE: ./pages/health-insurance/no-gap/[slug]/index.page.tsx



var NoGapPage = function(param) {
    var noGapDetailData = param.noGapDetailData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detail, {
        noGapDetailData: noGapDetailData
    });
};
var __N_SSP = true;
/* harmony default export */ var index_page = (NoGapPage);


/***/ }),

/***/ 86662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23094);

var productListingOverlayShowing = function() {
    return {
        type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_LISTING_OVERLAY_SHOWING */ .pN
    };
};
var productListingOverlayHidden = function() {
    return {
        type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_LISTING_OVERLAY_HIDDEN */ .IU
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    productListingOverlayHidden: productListingOverlayHidden,
    productListingOverlayShowing: productListingOverlayShowing
});


/***/ }),

/***/ 51413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _image_url_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36175);


var getImageAttributes = function(param) {
    var imageObject = param.imageObject, height = param.height, width = param.width;
    var image = imageObject === null || imageObject === void 0 ? void 0 : imageObject.image;
    if (!(image === null || image === void 0 ? void 0 : image.asset)) {
        return null;
    }
    var ref;
    var caption = (ref = imageObject === null || imageObject === void 0 ? void 0 : imageObject.caption) !== null && ref !== void 0 ? ref : "";
    return {
        alt: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNull)(caption) ? "" : caption,
        // @ts-expect-error - Automatic, Please fix when editing this file
        src: (0,_image_url_builder__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(image).height(height).width(width).url()
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getImageAttributes);


/***/ }),

/***/ 36175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35420);
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6465);


/**
 * @param {object} source - Object from Sanity that contains information about the image.
 * @returns {object} Object that can be called with many functions to override behaviour.
 * To override sizing while preserving aspect ratio you can set either height or width to undefined.
 * If you currently have SVG sources, upload a jpg, or just set `.format('jpg')` to test your sizing is reasonable.
 * NOTE: for more detail on the usage of the imageUrlBuilder see https://www.sanity.io/docs/image-url.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var imageUrlBuilder = function(source) {
    return _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0___default()({
        dataset: _client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dataset */ .Z.dataset,
        projectId: _client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].projectId */ .Z.projectId
    })(source);
};
/* harmony default export */ __webpack_exports__["Z"] = (imageUrlBuilder);


/***/ }),

/***/ 50739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_get_footnote_serializer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50073);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89990);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96852);









var mapWithIndex = (0,_utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(lodash_fp__WEBPACK_IMPORTED_MODULE_2__.map);
var amountOfColumns = 2;
var largeThreshold = "60rem";
var ContentTilesSection = function(param) {
    var contentTiles = param.contentTiles;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(contentTiles)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: mapWithIndex(function(tiles, index) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .BorderGridContainer */ .sO, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .AxisSwitcher */ .e$, {
                    limit: amountOfColumns,
                    threshold: largeThreshold,
                    children: mapWithIndex(function(tile, tileIndex) {
                        var footnote = tile === null || tile === void 0 ? void 0 : tile.footnote;
                        var formattedCtas = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.map)(function(cta) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, cta), {
                                link: cta.url,
                                linkText: cta.name
                            });
                        }, tile.ctas);
                        var formattedTile = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, tile), {
                            ctas: formattedCtas
                        });
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
                            padding: "1rem",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .ContentTile */ .Jm, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, formattedTile), {
                                customSerializers: footnote ? (0,_utils_get_footnote_serializer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                                    footnote: footnote,
                                    variant: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_8___default().footnote)
                                }) : {}
                            }))
                        }, tileIndex);
                    }, tiles)
                })
            }, index);
        }, contentTiles)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentTilesSection);


/***/ }),

/***/ 93954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ how_it_works; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/content/utils/portable-text-to-plain/index.js
var portable_text_to_plain = __webpack_require__(64355);
var portable_text_to_plain_default = /*#__PURE__*/__webpack_require__.n(portable_text_to_plain);
;// CONCATENATED MODULE: ./src/client/components/sections/how-it-works-section/utils/get-has-small-details-variant/index.ts


// 180 characters is roughly 3 lines of text
var CHAR_LIMIT_DETERMINER = 180;
// @ts-expect-error - Automatic, Please fix when editing this file
var getHasSmallDetailsVariant = function(param) {
    var steps = param.steps;
    return (0,fp.some)(function(step) {
        var detailsStepText = portable_text_to_plain_default()((0,fp.get)("details")(step));
        return (0,fp.size)(detailsStepText) >= CHAR_LIMIT_DETERMINER;
    })(steps);
};
/* harmony default export */ var get_has_small_details_variant = (getHasSmallDetailsVariant);

// EXTERNAL MODULE: ./src/client/components/sections/how-it-works-section/styles.module.sass
var styles_module = __webpack_require__(49659);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/client/components/sections/wrapped-section/index.tsx
var wrapped_section = __webpack_require__(51878);
;// CONCATENATED MODULE: ./src/client/components/sections/how-it-works-section/index.tsx







var importanceVariant = {
    high: [
        "purple"
    ],
    low: [
        "border",
        "white"
    ],
    medium: null
};
var HowItWorksSection = function(param) {
    var cta = param.cta, steps = param.steps, title = param.title;
    var hasSmallDetailsVariant = get_has_small_details_variant({
        steps: steps
    });
    var detailsVariant = hasSmallDetailsVariant ? (styles_module_default()).smallDetails : (styles_module_default()).largeDetails;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(wrapped_section/* default */.Z, {
        spacerSize: 1,
        withBorder: true,
        withWide: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                    variant: [
                        "marginBottomSpacer3",
                        "center"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                        source: title
                    })
                }),
                (0,fp.map)(function(param) {
                    var details = param.details, image = param.image, stepTitle = param.title, titlePrefix = param.titlePrefix, urlObject = param.urlObject;
                    var linkText = (0,fp.get)("name")(urlObject);
                    var linkUrl = (0,fp.get)("url")(urlObject);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).step,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* ImageLockup */.CF, {
                            imageSrc: (0,fp.get)("src")(image),
                            title: stepTitle,
                            titlePrefix: titlePrefix,
                            variant: [
                                "simpleBit",
                                (styles_module_default()).imageLockup
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                                    variant: detailsVariant,
                                    source: details
                                }),
                                linkText && linkUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                    to: linkUrl,
                                    variant: detailsVariant,
                                    children: linkText
                                })
                            ]
                        })
                    }, (0,fp.kebabCase)(stepTitle));
                })(steps),
                cta && cta.url && cta.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                    variant: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                        to: cta.url,
                        variant: importanceVariant[cta.importance],
                        children: cta.name
                    })
                })
            ]
        })
    });
};
HowItWorksSection.defaultProps = {
    cta: null
};
/* harmony default export */ var how_it_works_section = (HowItWorksSection);

// EXTERNAL MODULE: ./src/client/cms/utils/get-image-attributes/index.ts
var get_image_attributes = __webpack_require__(51413);
// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/components/how-it-works/map-steps-content/index.ts



// @ts-expect-error - Automatic, Please fix when editing this file
var mapStepsContent = function(steps) {
    return (0,uncap_fp_iterator/* default */.Z)(fp.map)(// @ts-expect-error - Automatic, Please fix when editing this file
    function(param, index) {
        var description = param.description, imageObject = param.imageObject, name = param.name, urlObject = param.urlObject;
        return {
            details: description,
            image: (0,get_image_attributes/* default */.Z)({
                height: 156,
                imageObject: imageObject
            }),
            title: name,
            titlePrefix: (0,fp.toString)(index + 1),
            urlObject: urlObject
        };
    }, steps);
};
/* harmony default export */ var map_steps_content = (mapStepsContent);

;// CONCATENATED MODULE: ./src/client/components/how-it-works/index.tsx





var HowItWorks = function(param) {
    var howTo = param.howTo;
    var steps = (0,fp.get)("steps")(howTo);
    if ((0,fp.isEmpty)(steps)) {
        return null;
    }
    var urlObject = (0,fp.get)("urlObject")(howTo);
    var cta = urlObject ? {
        importance: (0,fp.get)("importance")(howTo),
        name: (0,fp.get)("name")(urlObject),
        url: (0,fp.get)("url")(urlObject)
    } : null;
    var mappedSteps = map_steps_content(steps);
    // @ts-expect-error - Automatic, Please fix when editing this file
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(how_it_works_section, {
        cta: cta,
        title: (0,fp.get)("slogan")(howTo),
        steps: mappedSteps
    });
};
/* harmony default export */ var how_it_works = (HowItWorks);


/***/ }),

/***/ 27440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87205);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_3__);




var TermsSection = function(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "Things you should know" : _heading, _id = param.id, id = _id === void 0 ? "terms" : _id, termsComponent = param.termsComponent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .BorderGridContainer */ .sO, {
        hideBorderTop: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .SpacerWrapper */ .Cj, {
                    variant: [
                        "paddingTopSpacer2",
                        "paddingBottomSpacer2"
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .AxisSwitcher */ .e$, {
                        limit: 2,
                        threshold: "44rem",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
                                padding: "1rem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    "data-testid": "terms-heading-wrapper",
                                    id: id,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.H2, {
                                        looksLike: "h3",
                                        variant: "marginBottomSpacer9",
                                        children: heading
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
                                minWidth: "calc((100% / 10) * 6)",
                                padding: "1.5rem 1rem 1rem 1rem",
                                children: termsComponent
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsSection);


/***/ }),

/***/ 51878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42262);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_4__);





var WrappedSection = function(param) {
    var children = param.children, variant = param.variant, withBorder = param.withBorder, withInvert = param.withInvert, withWide = param.withWide, spacerSize = param.spacerSize;
    var section = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Section */ .$0, {
        variant: [
            "paddingTopSpacer".concat(spacerSize),
            "paddingBottomSpacer".concat(spacerSize),
            (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().section),
            variant
        ],
        children: children
    });
    return withBorder ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .BorderGridContainer */ .sO, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
            padding: "0",
            backgroundColor: withInvert ? "black" : "white",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([
                    (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().horizontalSpacingWrapper),
                    withInvert ? (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().invert) : null,
                    withWide ? (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().wide) : null, 
                ]),
                children: section
            })
        })
    }) : section;
};
WrappedSection.defaultProps = {
    spacerSize: 3,
    variant: null,
    withBorder: false,
    withInvert: false,
    withWide: false
};
/* harmony default export */ __webpack_exports__["Z"] = (WrappedSection);


/***/ }),

/***/ 47828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26717);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_4__);





// @ts-expect-error - Automatic, Please fix when editing this file
var wrapDescription = function(description) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.isArray)(description) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
        source: description
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Markdown */ .UG, {
        children: description
    });
};
var TermsAndConditions = function(param) {
    var terms = param.terms;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.map)(function(param) {
            var title = param.title, descriptionRaw = param.descriptionRaw, footnote = param.footnote, cta = param.cta;
            var hasCta = !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.isUndefined)(cta);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.H3, {
                        looksLike: "small",
                        variant: "marginBottomSpacer11",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.P, {
                        variant: hasCta ? "marginBottomSpacer10" : "marginBottomSpacer9",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Small */ .x4, {
                            children: [
                                footnote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: footnote.linkId,
                                    className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().footnotePrefix),
                                    children: footnote.reference
                                }),
                                wrapDescription(descriptionRaw)
                            ]
                        })
                    }),
                    hasCta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Clickable */ .P3, {
                        icon: {
                            name: cta.icon,
                            size: "small"
                        },
                        to: cta.url,
                        variant: "marginBottomSpacer9",
                        children: cta.title
                    })
                ]
            }, title);
        }, terms)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsAndConditions);


/***/ }),

/***/ 4529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

// @ts-expect-error - Automatic, Please fix when editing this file
var getIsNoGapDentalProduct = function(param) {
    var product = param.product, state = param.state;
    var ref, ref1;
    if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isPlainObject)(product) || !(product === null || product === void 0 ? void 0 : (ref = product.features) === null || ref === void 0 ? void 0 : ref.noGapDental)) {
        return false;
    }
    var limitedStates = product === null || product === void 0 ? void 0 : (ref1 = product.features) === null || ref1 === void 0 ? void 0 : ref1.noGapDentalLimited;
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(limitedStates) || (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(state, limitedStates);
};
/* harmony default export */ __webpack_exports__["Z"] = (getIsNoGapDentalProduct);


/***/ }),

/***/ 14518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84701);
/* harmony import */ var _utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93216);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2798);
/* harmony import */ var _product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43735);





// @ts-expect-error - Automatic, Please fix when editing this file
var componentDidMount = function(param) {
    var actions = param.actions, customer = param.customer, products = param.products, useFutureEffectiveDate = param.useFutureEffectiveDate;
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flow)(function(productIds) {
        return _product__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getProducts */ .Z.getProducts(products, productIds);
    }, function(productsArray) {
        return _product__WEBPACK_IMPORTED_MODULE_4__/* ["default"].filterAvailableProducts */ .Z.filterAvailableProducts(productsArray, customer);
    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)("id"), function(productIdsToLoad) {
        return actions.price.load(productIdsToLoad, customer, {
            date: (0,_utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(useFutureEffectiveDate)
        });
    })((0,_utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)());
};
// @ts-expect-error - Automatic, Please fix when editing this file
var componentWillReceiveProps = function(thisProps, nextProps) {
    var thisDate = (0,_utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(thisProps.useFutureEffectiveDate);
    var nextDate = (0,_utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(nextProps.useFutureEffectiveDate);
    // Load prices for available products if the prop change could change pricing.
    var customerChange = ___WEBPACK_IMPORTED_MODULE_3__/* ["default"].getKey */ .Z.getKey("", thisProps.customer, {
        date: thisDate
    }) !== ___WEBPACK_IMPORTED_MODULE_3__/* ["default"].getKey */ .Z.getKey("", nextProps.customer, {
        date: nextDate
    });
    var changedProducts = !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEqual)(thisProps.products, nextProps.products);
    if (customerChange || changedProducts) {
        var customer = nextProps.customer, products = nextProps.products, useFutureEffectiveDate = nextProps.useFutureEffectiveDate;
        var actions = thisProps.actions; // Not sure why this isn’t from next props
        componentDidMount({
            actions: actions,
            customer: customer,
            products: products,
            useFutureEffectiveDate: useFutureEffectiveDate
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    componentDidMount: componentDidMount,
    componentWillReceiveProps: componentWillReceiveProps
});


/***/ }),

/***/ 58496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




var HeaderSection = function(param) {
    var name = param.name, slogan = param.slogan, summary = param.summary;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .BorderGridContainer */ .sO, {
        hideBorderTop: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .FullScreenHeader */ .Ld, {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
                    source: slogan
                }),
                subtitle: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
                    source: summary
                }),
                scrollToElementText: "The ins and outs of ".concat((0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.toLower)(name)),
                scrollToNextElement: true
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderSection);


/***/ }),

/***/ 58699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ CMS_CONTENT_SECTIONS; },
/* harmony export */   "i": function() { return /* binding */ CONTENT_SECTIONS; }
/* harmony export */ });
// order matters as it defined the order of the sections in the page
/* eslint-disable sort-keys */ var CONTENT_SECTIONS = {
    AWARD: "award",
    HEADER: "header",
    PROMOTIONS: "promotions",
    OFFER_STRIP: "offerStrip",
    COVER_INCLUSIONS: "coverInclusions",
    VALUE_PROPOSITIONS: "valuePropositionGroup",
    CORE_BENEFITS: "coreBenefits",
    PRODUCTS: "productsByType",
    RELEVANT_ADD_ONS: "relevantAddOns",
    FEATURES_AND_BENEFITS: "featuresAndBenefits",
    INCLUSIONS: "inclusions",
    CONTACT_DETAILS: "contactDetails",
    ADD_ONS: "productConfigGroup",
    POPULAR_DESTINATIONS: "popularDestinations",
    PRODUCT_LIST: "productList",
    COMMON_QUESTIONS_ALTERNATE: "commonQuestionsAlternate",
    TILES: "tiles",
    FORMS_AND_GUIDES: "formsAndGuides",
    COMMON_QUESTIONS: "commonQuestions",
    QUICK_LINKS: "quickLinks",
    CROSS_SELL: "crossSell",
    ARTICLES: "articles",
    TERMS_AND_CONDITIONS: "termsAndConditions"
};
var CMS_CONTENT_SECTIONS = {
    HEADER: "brandCampaigns",
    PROMOTIONS: "promotions",
    OFFER_STRIP: "offer",
    VALUE_PROPOSITIONS: "valuePropositionGroup",
    FEATURES_AND_BENEFITS: "featuresAndBenefits",
    CONTACT_DETAILS: "contactDetails",
    TILES: "tiles",
    FORMS_AND_GUIDES: "formsAndGuides",
    COMMON_QUESTIONS: "questions",
    QUICK_LINKS: "quickLinks",
    TERMS_AND_CONDITIONS: "termsAndConditions",
    CROSS_SELL: "crossSell",
    PRODUCTS: "productsByType",
    ADD_ONS: "productConfigGroup",
    COMMON_QUESTIONS_ALTERNATE: "commonQuestions",
    RELEVANT_ADD_ONS: "relevantAddOns",
    CORE_BENEFITS: "coreBenefits",
    ARTICLES: "articles"
};


/***/ }),

/***/ 77013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _content_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58699);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93590);
/* harmony import */ var _cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51413);
/* harmony import */ var _utils_insert_footnote_reference__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74537);
/* harmony import */ var _utils_sort_tiles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2112);






var formatTiles = function(tiles) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(tile) {
        var ref = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.pick)([
            "title",
            "subtitle",
            "footnote",
            "imageObject",
            "urlObject"
        ], tile), title = ref.title, subtitle = ref.subtitle, footnote = ref.footnote, imageObject = ref.imageObject, urlObject = ref.urlObject;
        var formattedFootnote = footnote ? {
            linkId: "footnote-".concat(footnote),
            reference: footnote
        } : null;
        var tileSubtitle = formattedFootnote ? (0,_utils_insert_footnote_reference__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            footnote: formattedFootnote,
            text: subtitle
        }) : subtitle;
        var cta = urlObject ? [
            {
                name: urlObject.name,
                url: urlObject.url
            }
        ] : null;
        var image = (0,_cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            height: 240,
            imageObject: imageObject
        });
        var formattedTile = {
            // @ts-expect-error - Automatic, Please fix when editing this file
            ctas: cta,
            // @ts-expect-error - Automatic, Please fix when editing this file
            footnote: formattedFootnote,
            image: !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(image) ? image : null,
            subtitle: tileSubtitle,
            title: title,
            // @ts-ignore - Automatic, Please fix when editing this file
            urlObject: urlObject
        };
        return formattedTile;
    }, tiles);
};
var mapTiles = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    var tiles = cmsSectionContent;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(tiles)) {
        return null;
    }
    // @ts-expect-error - Automatic, Please fix when editing this file
    var formattedTiles = formatTiles(tiles);
    var sortedTiles = (0,_utils_sort_tiles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(formattedTiles, _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_2__.TILE_VARIANTS.VERTICAL_CENTER);
    return {
        content: sortedTiles,
        type: _content_sections__WEBPACK_IMPORTED_MODULE_1__/* .CONTENT_SECTIONS.TILES */ .i.TILES
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (mapTiles);


/***/ }),

/***/ 50073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85500);




var onClickFootnote = function(footnoteId) {
    return function() {
        (0,_ui__WEBPACK_IMPORTED_MODULE_3__/* .scrollToElement */ .kI)(document.getElementById(footnoteId));
    };
};
/* eslint-disable react/prop-types */ // @ts-expect-error - Automatic, Please fix when editing this file
var footnoteSerializer = function(footnoteId, variant) {
    return function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Clickable */ .P3, {
            variant: variant,
            onClick: onClickFootnote(footnoteId),
            children: props.node.text
        });
    };
};
/* eslint-disable react/prop-types */ // @ts-expect-error - Automatic, Please fix when editing this file
var getFootnoteSerializer = function(param) {
    var footnote = param.footnote, variant = param.variant;
    if (footnote) {
        return {
            footnote: footnoteSerializer(footnote.linkId, variant)
        };
    }
    return {};
};
/* harmony default export */ __webpack_exports__["Z"] = (getFootnoteSerializer);


/***/ }),

/***/ 84701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47569);

var getFutureDate = function(useFutureEffectiveDate) {
    return useFutureEffectiveDate ? _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FUTURE_EFFECTIVE_DATE */ .Z.FUTURE_EFFECTIVE_DATE : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFutureDate);


/***/ }),

/***/ 74537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ FOOTNOTE_PLACEHOLDER; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_generate_portable_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5398);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_generate_portable_text__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_utils_generate_portable_text__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64355);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2__);



var FOOTNOTE_PLACEHOLDER = "[FOOTNOTE_PLACEHOLDER]";
var insertFootnoteReference = function(param) {
    var text = param.text, footnote = param.footnote;
    var isPortableText = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isArray)(text) || (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isPlainObject)(text);
    var textContent = isPortableText ? _ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2___default()(text) : text;
    var splitText = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.split)(FOOTNOTE_PLACEHOLDER, textContent);
    return _ahmdigital_logic_lib_content_utils_generate_portable_text__WEBPACK_IMPORTED_MODULE_1___default()({
        value: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.concat)([
            {
                value: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.head)(splitText)
            },
            footnote && {
                type: "footnote",
                value: footnote.reference
            }
        ], (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(trailingText) {
            return {
                value: trailingText
            };
        }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.tail)(splitText))))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (insertFootnoteReference);


/***/ }),

/***/ 591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);


// @ts-expect-error - Automatic, Please fix when editing this file
var isProductBestSeller = function(param) {
    var scale = param.scale, parentProductId = param.parentProductId, productId = param.productId, productType = param.productType;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly hospital: { readonly single: "starter-bronze"; readonly couple: "simple-bronze-plus"; readonly family: "essentials-silver-plus"; readonly "single-parent": "core-bronze-plus"; }; readonly extras: { ...; }; readonly package: { ...; }; }'.
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.some)(function(id) {
        var ref;
        return id === (_ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST === null || _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST === void 0 ? void 0 : (ref = _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST[productType]) === null || ref === void 0 ? void 0 : ref[scale]);
    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)([
        parentProductId,
        productId
    ]));
};
/* harmony default export */ __webpack_exports__["Z"] = (isProductBestSeller);


/***/ }),

/***/ 24725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _pages_insurance_content_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58699);
/* harmony import */ var _map_terms_and_conditions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96816);



// @ts-expect-error - Automatic, Please fix when editing this file
var mapTermsAndConditionsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(cmsSectionContent)) {
        return null;
    }
    var mappedTermsAndConditions = {
        terms: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flatMap)(_map_terms_and_conditions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, cmsSectionContent),
        type: _pages_insurance_content_sections__WEBPACK_IMPORTED_MODULE_1__/* .CONTENT_SECTIONS.TERMS_AND_CONDITIONS */ .i.TERMS_AND_CONDITIONS
    };
    return mappedTermsAndConditions;
};
/* harmony default export */ __webpack_exports__["Z"] = (mapTermsAndConditionsContent);


/***/ }),

/***/ 96816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);




var mapTermsAndConditions = function(cmsTermsAndConditions) {
    if (!cmsTermsAndConditions) {
        return [];
    }
    var footnotes = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(footnote) {
        if (!footnote) {
            return null;
        }
        var descriptionRaw = footnote.descriptionRaw, linkReferenceSymbol = footnote.linkReferenceSymbol;
        return {
            descriptionRaw: descriptionRaw,
            footnote: {
                linkId: "footnote-".concat(linkReferenceSymbol),
                reference: linkReferenceSymbol || ""
            }
        };
    }, cmsTermsAndConditions.footnotes);
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)([
        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, cmsTermsAndConditions), {
            title: cmsTermsAndConditions.name || null
        })
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(footnotes)));
};
/* harmony default export */ __webpack_exports__["Z"] = (mapTermsAndConditions);


/***/ }),

/***/ 59794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export serviceMapper */
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_future_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84701);
/* harmony import */ var _is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(591);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2798);
/* harmony import */ var _models_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26789);





// @ts-expect-error - Automatic, Please fix when editing this file
var serviceMapper = function(feature) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(param) {
        var id = param.id, name = param.name;
        return {
            id: id,
            name: name
        };
    }, feature.services);
};
var prepareProductForProductTile = function(param) {
    var customer = param.customer, frequency = param.frequency, prices = param.prices, mlsAmount = param.mlsAmount, useFutureEffectiveDate = param.useFutureEffectiveDate;
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(product) {
        var ref;
        if (!product) {
            return null;
        }
        var id = product.id, additionalDetails = product.additionalDetails, charges = product.charges, content = product.content, ctaText = product.ctaText, extras = product.extras, features = product.features, hospital = product.hospital, hospitalTier = product.hospitalTier, name = product.name, rank = product.rank, type = product.type, ctaProductId = product.ctaProductId, parentProductId = product.parentProductId, unavailableWithExcessInfo = product.unavailableWithExcessInfo;
        var scale = customer.scale;
        var date = (0,_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(useFutureEffectiveDate);
        var price = _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getPrice */ .Z.getPrice(prices, id, customer, {
            date: date
        });
        var priceObject = price ? _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getAmountAsObject */ .Z.getAmountAsObject(price, frequency) : undefined;
        var saving = mlsAmount && priceObject ? Math.max(mlsAmount - parseFloat("".concat(priceObject.dollars, ".").concat(priceObject.cents)), 0) : undefined;
        var ref1;
        var hospitalFeatured = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.hospital) === null || ref === void 0 ? void 0 : ref.featured) !== null && ref1 !== void 0 ? ref1 : [];
        var hospitalServices = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flatMap)(serviceMapper, hospitalFeatured);
        return {
            additionalDetails: additionalDetails,
            charges: charges,
            content: content,
            ctaText: ctaText,
            extras: extras,
            features: features,
            frequency: frequency,
            hospital: hospital,
            hospitalTier: hospitalTier,
            id: id,
            isAvailable: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(scale, product.scales.supported),
            isBestSeller: (0,_is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                parentProductId: parentProductId,
                productId: id,
                productType: type,
                scale: scale
            }),
            name: name,
            price: priceObject,
            rank: rank,
            saving: saving,
            scale: customer.scale,
            services: hospitalServices,
            type: type,
            unavailableWithExcessInfo: unavailableWithExcessInfo,
            url: _models_url__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getProductUrl */ .Z.getProductUrl(ctaProductId || id)
        };
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (prepareProductForProductTile);



/***/ }),

/***/ 2112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);




var sortTiles = function(tiles, tileVariant) {
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(tiles) || !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isArray)(tiles)) {
        return [];
    }
    var rows = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.chunk)(2)(tiles);
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(row) {
        return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(tile) {
            if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.size)(row) === 1) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, tile), {
                    variant: _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.TILE_VARIANTS.FULL_WIDTH
                });
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, tile), {
                variant: tileVariant
            });
        })(row);
    })(rows);
};
/* harmony default export */ __webpack_exports__["Z"] = (sortTiles);


/***/ }),

/***/ 85500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X5": function() { return /* binding */ scrollTo; },
/* harmony export */   "kI": function() { return /* binding */ scrollToElement; },
/* harmony export */   "wA": function() { return /* binding */ getScrollPosition; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_is_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41105);


// Due to Firefox / Chrome following different standards. https://miketaylr.com/posts/2014/11/document-body-scrollTop.html
function getScrollPosition() {
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
}
function scrollTo() {
    var to = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var isServer = (0,_get_is_server__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    if (isServer) {
        return;
    }
    window.scrollTo({
        behavior: "smooth",
        top: to
    });
    // this is used for `back to top` button after being clicked, return tab order to where it has id `backToTopPoint`
    var backToTopPoint = document.getElementById("backToTopPoint");
    if (backToTopPoint) {
        backToTopPoint.focus({
            preventScroll: true
        });
    }
}
function scrollToElement(element) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNull)(element)) {
        return;
    }
    var scrollPosition = element.getBoundingClientRect().top + getScrollPosition() + offset;
    scrollTo(scrollPosition);
}


/***/ }),

/***/ 89990:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","footnote":"styles_footnote__eXfNE"};

/***/ }),

/***/ 49659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","container":"styles_container__MsfEr","step":"styles_step__mEZpd","smallDetails":"styles_smallDetails__l5_v8","largeDetails":"styles_largeDetails___cTI8"};

/***/ }),

/***/ 87205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","wrapper":"styles_wrapper__iO1nP"};

/***/ }),

/***/ 42262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__O7WkK","horizontalSpacingWrapper":"styles_horizontalSpacingWrapper__zwDaO","invert":"styles_invert__K85Fh","wide":"styles_wide__gsza_"};

/***/ }),

/***/ 48359:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","container":"styles_container__9RNHh","toggleWrapper":"styles_toggleWrapper__k_ERE"};

/***/ }),

/***/ 26717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","footnotePrefix":"styles_footnotePrefix__tLuT7"};

/***/ }),

/***/ 77688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","axisSwitcherWrapper":"styles_axisSwitcherWrapper__M7wI6","productTileWrapper":"styles_productTileWrapper__6Ghbm","productTile":"styles_productTile__p6ZRt","footnote":"styles_footnote__aBIS5"};

/***/ }),

/***/ 1241:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","column":"styles_column__riD_M","logo":"styles_logo___a_F_","city":"styles_city__GnneC","danielTan":"styles_danielTan__C2OmI","container":"styles_container__qbYdf"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1372,1849,9143,7022,9774,2888,179], function() { return __webpack_exec__(47714); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);